import client from '../config/AxiosConfig';

export const CreateUnsavedRoomPlan = async data => 
    client.post('/unsavedRoomPlan', data);
